
export default [
  {
    path:'asklog',
    name:'asklog',
    meta:{
      title:'单询记录-Co-logistics'
    },
    component: () => import("@/view/quotation/asklog/asklog.vue"),
  },
  {
    path:'eursale',
    name:'eursale',
    meta:{
      title:'海派单询-Co-logistics'
    },
    component: () => import("@/view/quotation/sea-sale.vue"),
  },
  {
    path:'eurbus',
    name:'eurbus',
    meta:{
      title:'海派单询-Co-logistics'
    },
    component: () => import("@/view/quotation/sea-business.vue"),
  },

  {
    path:'airothersale',
    name:'airothersale',
    meta:{
      title:'其它单询-Co-logistics'
    },
    component: () => import("@/view/quotation/other-sale.vue"),
  },
  {
    path:'airotherbus',
    name:'airotherbus',
    meta:{
      title:'其它单询-Co-logistics'
    },
    component: () => import("@/view/quotation/other-bus.vue"),
  },
  {
    path:'seacabinetsale',
    name:'seacabinetsale',
    meta:{
      title:'海运单询-Co-logistics'
    },
    component: () => import("@/view/quotation/sea_cabinetsale.vue"),
  },
  {
    path:'seacabinetbus',
    name:'seacabinetbus',
    meta:{
      title:'海运单询-Co-logistics'
    },
    component: () => import("@/view/quotation/sea_cabinetbus.vue"),
  },
  {
    path:'seacurboxsale',
    name:'seacurboxsale',
    meta:{
      title:'海运单询-Co-logistics'
    },
    component: () => import("@/view/quotation/sea_cutboxsale.vue"),
  },
  {
    path:'seacurboxbus',
    name:'seacurboxbus',
    meta:{
      title:'海运单询-Co-logistics'
    },
    component: () => import("@/view/quotation/sea_cutboxbus.vue"),
  },
]